import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-span',
  templateUrl: './span.component.html',
  styleUrls: ['./span.component.css']
})
export class SpanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
